import {eBienLaiViewTuyenSinhActionsObj} from "../../action-types/bien-lai/IBienLaiViewTuyenSinhActionTypes";
import {generateActions} from "../generateActions";

export const bienLaiViewTuyenSinhActions = {
    ...generateActions(
        eBienLaiViewTuyenSinhActionsObj,
        "BIEN_LAI_VIEW_TUYEN_SINH"
    ),
};
